import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.main');
@Component({
    selector: 'wiz-layout-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.main/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class LayoutMainComponent { }

export default LayoutMainComponent;